import { EMPTY_FIELD } from 'constants/emptyField';

import { SxProps, Theme } from '@mui/material';
import { RaRecord } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { Tooltip } from 'shared/mui/Tooltip';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';

import { StyledTypography } from './TooltipTextField.styled';

export type TooltipTextFieldProps<T extends RaRecord = RaRecord> = {
  onClick?: (record?: T) => void;
  source: keyof T;
  value?: string;
  sx?: SxProps<Theme>;
} & Omit<FunctionFieldProps, 'render' | 'onClick'>;

export const TooltipTextField = <T extends RaRecord = RaRecord>({
  onClick,
  source,
  sx,
  value,
  ...rest
}: TooltipTextFieldProps<T>) => (
  <FunctionField
    render={(record: T) => {
      if (!record[source]) {
        return EMPTY_FIELD;
      }
      return (
        <Box onClick={() => onClick?.(record)}>
          <Tooltip arrow title={<Typography fontSize={12}>{value || record[source]}</Typography>}>
            <StyledTypography component="span" sx={sx}>
              {value || record[source]}
            </StyledTypography>
          </Tooltip>
        </Box>
      );
    }}
    {...rest}
  />
);
